import { useState } from 'react';
import { useAtomValue } from 'jotai';
import classNames from 'classnames';
import styles from './SurveySection.module.scss';
import { theme } from '../../store/theme';
import Img from '../Img';

interface ISliderArrowProps {
  type: 'prev' | 'next';
}

const SliderArrow = ({ type }: ISliderArrowProps) => {
  const appTheme = useAtomValue(theme);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const arrowSrc = isHovered ? '/media/slider-arrow-right-hovered.svg' : `/media/slider-arrow-right-${appTheme}.svg`;

  return (
    <button
      type='button'
      className={classNames(`splide__arrow splide__arrow--${type}`, styles.arrow, styles?.[`arrow_${type}`])}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Img
        src={arrowSrc}
        alt='slider arrow right'
      />
    </button>
  );
};

export default SliderArrow;
